import React, { useEffect, useRef } from 'react';

import * as d3 from 'd3';

export function UsageBarChart({
  chartKey, className, width, barHeight, barWidth, data, valueFormat, color
}) {
  const chartRef = useRef();

  useEffect(() => {
    const marginTop = 10;
    const marginRight = 0;
    const marginBottom = 20;
    const marginLeft = 55;
    const height = barHeight + marginBottom;
    const topCornerRadius = 4;
    const valueTickMarginLeft = 4;

    chartRef.current.innerHTML = "";

    const svg = d3.select(chartRef.current)
      .append("svg").attr("viewBox", [0, 0, width, height])
      .attr("width", width)
      .attr("height", height);

    // top corner clipPath
    const clipPath = svg.append("clipPath")
      .attr("id", chartKey + "-chart-top-corner-clipPath");
    clipPath.append("rect")
      .attr("width", width)
      .attr("height", barHeight)
      .attr("x", 0)
      .attr("y", 0);

    const x = d3.scaleBand()
      .domain(data.map(d => d.label))
      .range([marginLeft, width - marginRight])
      .padding(0.1);

    let yMin = d3.min(data, (d) => d.value);
    const yMax = d3.max(data, (d) => d.value);
    yMin = Math.max(yMax - (yMax - yMin) * 2, 0);
    const y = d3.scaleLinear()
      .domain([yMin, yMax])
      .range([height - marginBottom, marginTop]);

    // x-axis
    svg.append("g")
      .attr("transform", `translate(0,${height - marginBottom})`)
      .attr("color", "white")
      .call(d3.axisBottom(x).tickSizeOuter(0))
      .call(g => g.selectAll(".tick").select("line").remove())
      .call(g => g.select(".domain").attr("stroke-opacity", 0.6));

    // y-axis
    const linesWidth = width - marginLeft - marginRight;
    svg.append("g")
      .attr("transform", `translate(${marginLeft},0)`)
      .attr("color", "white")
      .call(d3.axisLeft(y)
        .tickSize(-linesWidth)
        .ticks(3).tickFormat(valueFormat))
      .call(g => g.selectAll(".tick").select("line")
        .attr("stroke-width", 0.5)
        .attr("stroke-opacity", 0.3)
        .attr("stroke-dasharray", "2,2")
      )
      .call(g => g.selectAll(".tick").select("text")
        .attr("transform", `translate(${-valueTickMarginLeft},0)`)
        .attr("class", "y-text")
      )
      .call(g => g.select(".domain").remove());

    const xOffset = (x.bandwidth() - barWidth) / 2;
    // Add a rect for each bar.
    svg.append("g")
      .attr("fill", color)
      .selectAll()
      .data(data)
      .join("rect")
      .attr("x", (d) => xOffset + x(d.label))
      .attr("y", (d) => y(d.value))
      .attr("height", (d) => topCornerRadius + y(yMin) - y(d.value))
      .attr("width", barWidth)
      .attr("rx", topCornerRadius)
      .attr("clip-path", `url(#${chartKey + "-chart-top-corner-clipPath"})`);


  }, [chartKey, className, width, barHeight, data, valueFormat, color, barWidth]);


  return (
    <div className={className} ref={chartRef} />
  );
}

/**
  <UsageBarChart
    chartKey="playground-svg" className="playground-svg"
    width={300}
    barHeight={65} barWidth={24}
    color="#FFD94D"
    data={[
        {value: 140, label: "two weeks ago"},
        {value: 120, label: "last week"},
        {value: 100, label: "this week"},
    ]}
    valueFormat={(v) => `${v.toFixed()} hours`}
/>
*/